var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BuilderBtnItem',{attrs:{"icon":"magic","title":"Setup Wizard","disabled":_vm.disabled,"icon-size":_vm.iconSize},on:{"click":function($event){return _vm.$bvModal.show('builder-wizard-modal')}}})}
var staticRenderFns = []

export { render, staticRenderFns }